import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { allianceDetailsManager, type IAllianceDetail } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { getAccessControlModule } from '../base/access-control/module';
import { actions } from './actions';

const ALLIANCE_DETAIL_MODULE = 'allianceDetail';

const dataObjectModule = getDataObjectsModule<IAllianceDetail>(allianceDetailsManager);
const searchModule = getSearchModule<IAllianceDetail>(allianceDetailsManager);
const accessControlModule = getAccessControlModule<IAllianceDetail>(allianceDetailsManager);

const allianceDetailModuleInstance = merge<unknown>(dataObjectModule, searchModule, accessControlModule, { actions });
store.registerModule(ALLIANCE_DETAIL_MODULE, allianceDetailModuleInstance);

export { ALLIANCE_DETAIL_MODULE };
